import { useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'

import { getFilesAPI } from 'api/files'
import { useFilesStore } from 'store/files'
import { DropDownItem } from 'types/components'
import { DATASTATUS } from 'constants/status'
import { FilesDataTypes } from 'schemas/files'

export const useFiles = (fileTypeId?: number) => {
  const filesModStatus = useFilesStore((state) => state.filesModStatus)
  const filesModStatusSet = useFilesStore((state) => state.filesModStatusSet)
  const filesModErrors = useFilesStore((state) => state.filesModErrors)
  const filesModErrorsSet = useFilesStore((state) => state.filesModErrorsSet)
  const files = useFilesStore((state) => state.files)
  const filesSet = useFilesStore((state) => state.filesSet)

  const {
    data: dataFiles,
    isLoading: isLoadingFiles,
    isError: isErrorFiles,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useFiles', fileTypeId],
    enabled: fileTypeId != null,
    queryFn: async () => {
      try {
        filesModStatusSet('loading')
        const response = await getFilesAPI(fileTypeId)
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        filesModStatusSet('success')
        return response
      } catch (e) {
        filesModStatusSet('fail')
        filesModErrorsSet(JSON.stringify(e))
      }
    },
  })

  useEffect(() => {
    if (dataFiles) filesSet(dataFiles.files)
  }, [dataFiles, filesSet])

  const filesOptions: DropDownItem[] = useMemo(() => {
    return files.map((item) => ({
      label: String(item.fileName + ' | ' + item.creationDate.replace('T', ' ').slice(0, 19)),
      value: String(item.fileName),
    }))
  }, [files])

  const selectedFile: FilesDataTypes | undefined = useMemo(() => {
    return files.length > 0 ? files[0] : undefined
  }, [files])

  return {
    filesOptions,
    files,
    filesModStatus,
    filesModErrors,
    selectedFile,
  }
}
